"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicalObjectQuerySchema = exports.ComplexQueryValueSchema = exports.ObjectQuerySchema = exports.BaseObjectQuerySchema = exports.QueryOptionsSchema = exports.QueryValueSchema = void 0;
const zod_1 = require("zod");
const QueryOptions = {
    I: 'i',
    G: 'g',
    M: 'm',
    U: 'u',
};
//zod below
exports.QueryValueSchema = zod_1.z.union([zod_1.z.number(), zod_1.z.string(), zod_1.z.boolean()]);
exports.QueryOptionsSchema = zod_1.z.enum(['i', 'g', 'm', 'u']);
exports.BaseObjectQuerySchema = zod_1.z.object({
    $eq: exports.QueryValueSchema.optional(),
    $ne: exports.QueryValueSchema.optional(),
    $lt: exports.QueryValueSchema.optional(),
    $gt: exports.QueryValueSchema.optional(),
    $lte: exports.QueryValueSchema.optional(),
    $gte: exports.QueryValueSchema.optional(),
    $in: exports.QueryValueSchema.array().optional(),
    $nin: exports.QueryValueSchema.array().optional(),
    $all: exports.QueryValueSchema.array().optional(),
    $mod: zod_1.z.tuple([zod_1.z.number(), zod_1.z.number()]).optional(),
    $exists: zod_1.z.boolean().optional(),
    $regex: zod_1.z.string().optional(),
    $size: zod_1.z.number().optional(),
    $where: zod_1.z.string().optional(),
    $options: exports.QueryOptionsSchema.optional(),
});
exports.ComplexQueryValueSchema = zod_1.z
    .record(zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean(), zod_1.z.lazy(() => exports.ObjectQuerySchema)]))
    .or(zod_1.z.lazy(() => exports.ObjectQuerySchema));
exports.LogicalObjectQuerySchema = zod_1.z.object({
    $not: zod_1.z.lazy(() => exports.ObjectQuerySchema).optional(),
    $or: zod_1.z.array(exports.ComplexQueryValueSchema).optional(),
    $nor: zod_1.z.array(exports.ComplexQueryValueSchema).optional(),
    $and: zod_1.z.array(exports.ComplexQueryValueSchema).optional(),
});
exports.ObjectQuerySchema = exports.BaseObjectQuerySchema.extend(exports.LogicalObjectQuerySchema.shape).strict();
//# sourceMappingURL=objectQuery.js.map